import _ from 'lodash';
import { noneAssignedOption } from 'src/components/Dashboard/utils/filterDefaults';
import { getGroupUsersOptions, getSentByOptions } from 'src/components/Groups/Users/utils';
import { getReasonsOptions } from 'src/components/Groups/utils';
import subNetworksFilter from 'src/components/Dashboard/utils/subNetworksFilter';
import {
  consentStatusFilter,
  serviceTypesFilter,
} from 'src/components/Dashboard/utils/filter';
import filterVisibility from './filterVisibility';
import sortStatuses from './sortStatuses';

function buildSentReferralsFilters({
  serviceTypes,
  state,
  activeUsersInGroup,
  employees,
  currentEmployee,
  showMoreFilters,
  target,
  routeStatus,
  labels,
  reasons,
  currentGroup,
  fetchSentByUsers,
  partialPath,
  statuses,
}) {
  return filterVisibility(_.compact([
    serviceTypesFilter(serviceTypes, state.filters.service_types),
    {
      key: 'care_coordinator_users',
      name: labels.CareCoordinator,
      pluralName: `${labels.CareCoordinator}s`,
      options: _.concat(
        [noneAssignedOption(state.filters.care_coordinator_users)],
        getGroupUsersOptions(activeUsersInGroup, state),
      ),
    },
    {
      key: 'sent_by',
      name: 'Sent By',
      pluralName: 'Sent By',
      options: getSentByOptions(employees, state, currentEmployee),
      asyncSearch: fetchSentByUsers,
      secondary: !showMoreFilters && target === 'sentReferralsAll',
    },
    ['pending', 'all'].includes(routeStatus) ?
      consentStatusFilter(state.filters.consent_status) : null,
    {
      key: 'status',
      name: 'Status',
      single: false,
      options: sortStatuses(statuses, true),
      value: state.filters.status,
    },
    {
      key: 'resolved',
      name: 'Resolution',
      single: false,
      options: [
        { label: 'Resolved', value: true },
        { label: 'Unresolved', value: false },
      ],
      value: state.filters.resolved,
    },
    {
      key: 'reasons',
      name: 'Reason',
      pluralName: 'Reasons',
      options: getReasonsOptions(reasons, state),
    },
    subNetworksFilter(currentGroup, state.filters.networks, true),
  ]), partialPath);
}

export default buildSentReferralsFilters;
